import publicIpService from './publicIpService';

// Authentication service for managing JWT tokens
class AuthService {
  constructor() {
    this.TOKEN_KEY = 'jwt_token';
    this.USER_KEY = 'user_data';
  }

  // Store JWT token in localStorage
  setToken(token) {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  // Get JWT token from localStorage
  getToken() {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  // Remove JWT token from localStorage
  removeToken() {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem(this.USER_KEY);
  }

  // Store user data
  setUser(userData) {
    localStorage.setItem(this.USER_KEY, JSON.stringify(userData));
  }

  // Get user data
  getUser() {
    const userData = localStorage.getItem(this.USER_KEY);
    return userData ? JSON.parse(userData) : null;
  }

  // Check if user is authenticated
  isAuthenticated() {
    const token = this.getToken();
    const user = this.getUser();
    
    if (!token || !user) {
      console.log('🔐 No token or user data found');
      return false;
    }

    try {
      // Check if token is expired (basic check)
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      const isValid = payload.exp > currentTime;
      
      if (!isValid) {
        console.log('🔐 Token expired, clearing auth data');
        this.removeToken();
        return false;
      }
      
      return true;
    } catch (error) {
      console.error('🔐 Error checking token validity:', error);
      this.removeToken();
      return false;
    }
  }

  // Get authorization header and client public IP for API requests
  getAuthHeader() {
    const token = this.getToken();
    const headers = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const ipHeader = publicIpService.getPublicIpHeader();
    return { ...headers, ...ipHeader };
  }

  // Logout user
  logout() {
    this.removeToken();
  }
}

export default new AuthService();